import ApiClient from "../../api-client";
import { API_URL } from "../../environment";

export const createMeeting = ({values, dispatch, token}) => {
    return ApiClient.post(`${API_URL}/user/meetings/meeting`, values, token, dispatch);
};

export const getAllMeetings = ({values, dispatch, token}) => {
    return ApiClient.get(`${API_URL}/user/meetings/meetings?&orgId=${values?.orgId}&clinicId=${values?.clinicId}&date=${values?.date}&isDecline=${values?.isDecline}`, null, token, dispatch);
};

export const editMeeting = ({values, dispatch, token}) => {
    return ApiClient.put(`${API_URL}/user/meetings/meeting/${values?.eventId}`, values, token, dispatch);
};

export const updateMeeting = ({ values, token, meetingId }) => {
    return ApiClient.put(`${API_URL}/user/meetings/meeting/${meetingId}`, values, token);
};
